import { CheckCircle2, Info, X, XCircle } from "lucide-react";
import { createContext, useCallback, useContext, useMemo, useState } from "react";

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = "success") => {
    const id = crypto.randomUUID();
    setToasts((items) => [...items, { id, message, type }]);
    window.setTimeout(() => {
      setToasts((items) => items.filter((toast) => toast.id !== id));
    }, 3200);
  }, []);

  const value = useMemo(() => ({ showToast }), [showToast]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="fixed right-4 top-4 z-[80] w-[min(360px,calc(100vw-32px))] space-y-2" aria-live="polite">
        {toasts.map((toast) => {
          const Icon = toast.type === "error" ? XCircle : toast.type === "info" ? Info : CheckCircle2;
          return (
            <div
              key={toast.id}
              className={`flex items-start gap-3 rounded-md border bg-white p-3 shadow-soft dark:border-slate-700 dark:bg-slate-900 ${
                toast.type === "error" ? "border-error-600/30" : "border-success-600/30"
              }`}
              role="status"
            >
              <Icon
                className={`mt-0.5 h-5 w-5 ${toast.type === "error" ? "text-error-600" : "text-success-600"}`}
                aria-hidden="true"
              />
              <p className="flex-1 text-sm font-semibold text-slate-800 dark:text-slate-100">{toast.message}</p>
              <button
                type="button"
                onClick={() => setToasts((items) => items.filter((item) => item.id !== toast.id))}
                className="rounded p-1 text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-800"
                aria-label="Tutup notifikasi"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          );
        })}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used inside ToastProvider");
  }
  return context;
}
